export default "__VITE_ASSET__B$17JsiL__"